/**
 * Import Lib
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import containers & components
 */

import { Shadow__background } from "components/shadow/shadow";
import Layout__wrapper from "containers/layout/wrapper/layout__wrapper";

/**
 * styled components
 */

const Container = styled.div`
  position: relative;
  background-color: transparent;
  padding: 60px 0 69px 0;
  ${t.mixins.flex()}
  ${t.mixins.sm(`
    padding: 36px 0;
  `)}
`;

/**
 * @name Layout__container
 * @property pageName: name of the page
 * @property children: child content
 */

const Layout__container = ({ style, pageName, children }) => (
  <Container style={style}>
    <Layout__wrapper>{children}</Layout__wrapper>
    <Shadow__background />
  </Container>
);

Layout__container.propTypes = {
  /**
    A custom style object
    */
  children: PropTypes.node,
  /**
    Define the page name
    */
  pageName: PropTypes.string,
  /**
    A children object to render content inside the components
    */
  style: PropTypes.object,
};

Layout__container.defaultProps = {
  style: {},
  pageName: "home",
  children: null,
};

export default Layout__container;
